import { render, staticRenderFns } from "./file-element.vue?vue&type=template&id=4bb6e8cb&scoped=true"
import script from "./file-element.vue?vue&type=script&lang=js"
export * from "./file-element.vue?vue&type=script&lang=js"
import style0 from "./file-element.vue?vue&type=style&index=0&id=4bb6e8cb&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb6e8cb",
  null
  
)

export default component.exports